import { useLocalization } from "@faire/web--source/common/localization/useLocalization";
import { useCallback } from "react";
export var useLocalNum = function() {
    var currencyFormatLocale = useLocalization().currencyFormatLocale;
    var localNumHook = useCallback(function(value, opts) {
        if (value === undefined) {
            return undefined;
        }
        return Intl.NumberFormat(currencyFormatLocale, opts).format(value);
    }, [
        currencyFormatLocale
    ]);
    return {
        localNum: localNumHook
    };
};
